import apiRoutes from './api.routes';
import ModelService from './model.service';

const ProductTypesItemsService = new ModelService(apiRoutes.projectTypesItems, '/project-types/items', 'content');


ProductTypesItemsService.getImage = (filename, w = false, h = false, c = false) => ProductTypesItemsService.getFilePathByDir('/uploads/project-types', filename, w, h, c);
/** Types */

ProductTypesItemsService.getIcon = (filename) => ProductTypesItemsService.getFilePathByDir('', filename);

ProductTypesItemsService.ICON_HANDS_GREEN = '/img/product-types/icons/hands_green.png';
ProductTypesItemsService.ICON_HANDS_PURPLE = '/img/product-types/icons/hands_purple.png';
ProductTypesItemsService.ICON_DATABASE_ORANGE = '/img/product-types/icons/database_orange.png';
ProductTypesItemsService.ICON_DATABASE_BLUE = '/img/product-types/icons/database_blue.png';
ProductTypesItemsService.ICON_WALLET = '/img/product-types/icons/wallet.png';
ProductTypesItemsService.ICON_SETTINGS_BLUE = '/img/product-types/icons/settings_blue.png';
ProductTypesItemsService.ICON_SETTINGS_PURPLE = '/img/product-types/icons/settings_purple.png';
ProductTypesItemsService.ICON_BALL = '/img/product-types/icons/ball.png';
ProductTypesItemsService.ICON_PIE = '/img/product-types/icons/pie.png';
ProductTypesItemsService.ICON_NOTE_BLUE = '/img/product-types/icons/note_blue.png';
ProductTypesItemsService.ICON_NOTE_ORANGE = 'note_orange.png';
ProductTypesItemsService.ICON_CLOCK = '/img/product-types/icons/clock.png';
ProductTypesItemsService.ICON_CHART_BLUE = '/img/product-types/icons/chart_blue.png';
ProductTypesItemsService.ICON_CHAT = '/img/product-types/icons/chat.png';
ProductTypesItemsService.ICON_SEARCH = '/img/product-types/icons/search.png';
ProductTypesItemsService.ICON_MOUNTAINS_BLUE = '/img/product-types/icons/mountains_blue.png';
ProductTypesItemsService.ICON_MOUNTAINS_ORANGE = '/img/product-types/icons/mountains_orange.png';
ProductTypesItemsService.ICON_MOUNTAINS_GREEN = '/img/product-types/icons/mountains_green.png';
ProductTypesItemsService.ICON_STAR = '/img/product-types/icons/star.png';
ProductTypesItemsService.ICON_COFFEE = '/img/product-types/icons/coffee.png';
ProductTypesItemsService.ICON_PEOPLE_PURPLE = '/img/product-types/icons/people_purple.png';
ProductTypesItemsService.ICON_PEOPLE_ORANGE = '/img/product-types/icons/people_orange.png';
ProductTypesItemsService.ICON_CURSOR = '/img/product-types/icons/cursor.png';
ProductTypesItemsService.ICON_TOGGLE = '/img/product-types/icons/toggle.png';

ProductTypesItemsService.getTypeList = t => ({
  [ProductTypesItemsService.ICON_HANDS_GREEN]: t('Hands'),
  [ProductTypesItemsService.ICON_HANDS_PURPLE]: t('Hands'),
  [ProductTypesItemsService.ICON_DATABASE_ORANGE]: t('Database'),
  [ProductTypesItemsService.ICON_DATABASE_BLUE]: t('Database'),
  [ProductTypesItemsService.ICON_SETTINGS_BLUE]: t('Settings'),
  [ProductTypesItemsService.ICON_SETTINGS_PURPLE]: t('Settings'),
  [ProductTypesItemsService.ICON_BALL]: t('Ball'),
  [ProductTypesItemsService.ICON_PIE]: t('Pie'),
  [ProductTypesItemsService.ICON_NOTE_BLUE]: t('Note'),
  [ProductTypesItemsService.ICON_NOTE_ORANGE]: t('Note'),
  [ProductTypesItemsService.ICON_CHART_BLUE]: t('Chart'),
  [ProductTypesItemsService.ICON_CHAT]: t('Chat'),
  [ProductTypesItemsService.ICON_CLOCK]: t('Clock'),
  [ProductTypesItemsService.ICON_WALLET]: t('Wallet'),
  [ProductTypesItemsService.ICON_SEARCH]: t('Search'),
  [ProductTypesItemsService.ICON_MOUNTAINS_BLUE]: t('Mountains'),
  [ProductTypesItemsService.ICON_MOUNTAINS_ORANGE]: t('Mountains'),
  [ProductTypesItemsService.ICON_MOUNTAINS_GREEN]: t('Mountains'),
  [ProductTypesItemsService.ICON_STAR]: t('Star'),
  [ProductTypesItemsService.ICON_COFFEE]: t('Coffee'),
  [ProductTypesItemsService.ICON_PEOPLE_PURPLE]: t('People'),
  [ProductTypesItemsService.ICON_PEOPLE_ORANGE]: t('People'),
  [ProductTypesItemsService.ICON_CURSOR]: t('Cursor'),
  [ProductTypesItemsService.ICON_TOGGLE]: t('Toggle'),
});

ProductTypesItemsService.getTypeOptions = t => ProductTypesItemsService
  .prepareOptionsFromSimpleObject(ProductTypesItemsService.getTypeList(t));

  ProductTypesItemsService.getTypeTitle = (status, t) => {
  const label = ProductTypesItemsService.getTypeList(t)[status];
  return label || '-';
};

/** Positions */
ProductTypesItemsService.POSITION_HOME = 1;

ProductTypesItemsService.getPositionList = t => ({
  [ProductTypesItemsService.POSITION_HOME]: t('Home page'),
});

ProductTypesItemsService.getPositionOptions = t => ProductTypesItemsService
  .prepareOptionsFromSimpleObject(ProductTypesItemsService.getPositionList(t));

  ProductTypesItemsService.getPositionTitle = (status, t) => {
  const label = ProductTypesItemsService.getPositionList(t)[status];
  return label || '-';
};

export default ProductTypesItemsService;



// WEBPACK FOOTER //
// ./src/services/projectTypesItems.service.js